import { ConflitosAlocacaoDialog } from "@/shared/components/equipe-obra/conflitos-alocacao-dialog";
import { ProfissionalIndisponivelDialog } from "@/shared/components/equipe-obra/profissional-indisponivel-dialog";
import type {
  DivergenciasEquipeDialogsProps,
  DivergenciasEquipeDialogsViewModel,
} from "./types-divergencias-equipe-dialogs";

/**
 * Divergência apontada pelo servidor no Criar Obra (os dados mudaram depois da Etapa 4): reabre
 * os diálogos de Recursos com os dados do servidor, como o Salvar de Definir Equipe (HU 2059).
 * O servidor só manda ids: os nomes vêm das mesmas listas da Etapa 4, carregadas aqui.
 */
export function DivergenciasEquipeDialogsView(
  props: DivergenciasEquipeDialogsProps & DivergenciasEquipeDialogsViewModel,
) {
  const { obra, verificacoes, voltar } = props;

  return (
    <>
      {verificacoes.etapa?.tipo === "conflitos" ? (
        <ConflitosAlocacaoDialog
          obra={obra}
          conflitos={verificacoes.etapa.conflitos}
          maxJustificativa={verificacoes.maxJustificativa}
          onVoltar={voltar}
          onConfirmar={verificacoes.confirmarConflitos}
        />
      ) : null}

      {verificacoes.etapa?.tipo === "indisponivel" ? (
        <ProfissionalIndisponivelDialog
          itens={verificacoes.etapa.itens}
          maxJustificativa={verificacoes.maxJustificativa}
          onVoltar={voltar}
          onConfirmar={verificacoes.confirmarIndisponivel}
        />
      ) : null}
    </>
  );
}
